const sizeConfigs = {
  sidebar: {
    width: "220px",
    height: "100vh"
  }
};

export default sizeConfigs;
